import { render, staticRenderFns } from "./CrmKanban.vue?vue&type=template&id=0e6a56fc&"
import script from "./CrmKanban.vue?vue&type=script&lang=js&"
export * from "./CrmKanban.vue?vue&type=script&lang=js&"
import style0 from "./CrmKanban.vue?vue&type=style&index=0&id=0e6a56fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports